import { useI18n } from 'next-localization';
import ManualDisclaimer from 'components/Generic/ManualDisclaimer';
import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import { endpoints } from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/performanceEndpoints';
import { useFetchFundDetailsPerformanceQuery } from '@/store/fundDetails/services/fundDetailsApi';

type Props = {
  className: string;
  isThai?: boolean;
};

const FundDetailsPerformanceDisclaimer = ({ className, isThai = false }: Props) => {
  const { t } = useI18n();
  const { shareClass, language, countryCode, correlationFundRangeId, site, fund } = usePayload();
  const { data } = useFetchFundDetailsPerformanceQuery(
    {
      shareClass,
      language,
      countryCode,
      correlationFundRangeId,
      site,
      fund,
      endpoint: endpoints.DISCLAIMER,
    },
    {
      skip: !shareClass,
    }
  );

  if (isThai && data && data.length !== 0) {
    return (
      <FundDetailsTabRow className={className}>
        <ManualDisclaimer
          variant="secondary"
          title={t('fundDetailsPerformanceFootnoteTitle')}
          disclaimerData={data}
        />
      </FundDetailsTabRow>
    );
  }

  return (
    data &&
    data.length !== 0 && (
      <FundDetailsTabRow className={className} fullWidth>
        <ManualDisclaimer disclaimerData={data} />
      </FundDetailsTabRow>
    )
  );
};

export default FundDetailsPerformanceDisclaimer;
